enum Endpoints {
  Login = '/login',
  Refresh = '/refresh',
  SignUp = '/sign-up',
  ActivateUser = '/sign-up-confirm',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  Contact = '/contact-requests',
  DashboardShipPage = '/query/dashboard-buque',
  DashboardBuqueViajes = '/query/dashboard-operando-viajes',
  DashboardTerminalPage = '/query/dashboard-terminal',
  DashboardColdHubPage = '/query/dashboard-hubfrio',
  DashboardRoRoPage = '/query/dashboard-roro',
  DashboardRoRoViajes = 'query/dashboard-roro-viajes',
  Cfe = '/billing/cfe',
  Eir = '/billing/eir',
  SimuladorImport = 'billing/simulador-import',
  SimuladorExport = 'billing/simulador-export',
  Schedule = '/query/schedule',
  ScheduleFecha = '/query/schedule-fecha',
  ChangePassword = '/change-password',
  Trips = '/query/trips',
  ContainerList = '/query/container-list',
  BookingList = '/query/booking-list',
  UnloadingList = '/query/descargas-list',
  SolasList = '/query/solas-list',
  container = 'query/card-container',
  LiberacionImport = '/query/container-release',
  UpdateReleaseStatuses = '/billing/cambiar-estado-liberacion',
  StockNumber = '/query/stock-number',
  AssignList = '/query/assign-list',
  AssignTrips = '/query/trips-operated',
  DeliveryOrder = 'billing/delivery-order',
  StockContainers = '/query/stock-export',
  StockSummary = '/query/resumen-stock-list',
  LoadForecast = '/query/pronostico-carga',
  AgenciaArmadores = '/query/agencia-armadores',
  ContenedorStatus = 'query/status-release',
  ArmadoresList = '/query/armadores-list',
  BeachList = '/query/playas',
  ParteDeIntercambios = 'query/parte-intercambios-list',
  AvanceBuque = 'query/avance-buque',
  DetailedStock = '/query/detail-stock',
  StatusVisita = '/query/status-visita',
  TitularRut = '/billing/titular-rut',
  VerifyRut = '/billing/validar-rut',
  RegisterCustomer = '/billing/alta-cliente',
  Cities = '/billing/ciudades',
  Departments = '/billing/departamentos',
  ANPImport = '/query/anp-import',
  ANPExport = '/query/anp-export',
  ANPBooking = '/query/anp-booking',
  ANPSharedExport = '/query/anp-export-shared',
  PaymentsInquiry = '/billing/gastos-importacion',
  PaymentsInquiryExport = '/billing/gastos-exportacion',
  DocumentsWeb = '/billing/mis-documentos',
  DocumentsHistory = '/billing/documentos-usuario',
  DownloadDPDFocument = '/billing/documentos-pdf',
  SOLASEditVGM = '/query/edit-solas',
  MySettlement = '/billing/mis-liquidaciones',
  MySettlementDetail = '/billing/mis-liquidaciones-detalle',
  MySettlementDeliveryOrder = ' billing/mis-liquidaciones-delivery-orden',
  deletedMySettlement = 'billing/mis-liquidaciones-eliminar',
  CargarFormularioDepo20 = '/billing/mis-liquidaciones-buscar',
  Depo20ResultadosSeleccionados = '/billing/mis-liquidaciones-seleccionados',
  Depo20DetalleProforma = '/billing/mis-liquidaciones-obtener-detalle-proforma',
  Depo20DetalleProformaID = '/billing/mis-liquidaciones-proforma-id',
  Depo20QuitarProforma = '/billing/mis-liquidaciones-quitar-proforma',
  TieneCredito = '/billing/mis-liquidaciones-tiene-credito',
  TieneDiasCredito = '/billing/mis-liquidaciones-tiene-dias-credito',
  Depo20ComprobarDocumento = '/billing/mis-liquidaciones-comprobar-documento',
  Depo20ObtenerViaje = '/billing/mis-liquidaciones-obtener-viaje',
  ImportTableFCL = '/billing/mis-liquidaciones-visitas-con-reliquidadas',
  ImportFCLSchedule = '/billing/mis-liquidaciones-disponibilidad-agenda',
  AddContainersBL = '/query/mis-liquidaciones-contenedores-bl',
  ValidateContainerBL = '/billing/mis-liquidaciones-validar-fcl-import',
  ValidateContainerExport = '/billing/mis-liquidaciones-validar-fcl-export',
  ValidateContainerBooking = '/billing/mis-liquidaciones-validar-lleno-exportacion',
  LiquidateContainerBL = '/billing/mis-liquidaciones-liquidar-fcl-import',
  LiquidateContainerBLExport = '/billing/mis-liquidaciones-liquidar-exportacion',
  AddContainersBLImport = '/billing/mis-liquidaciones-agregar-visita-liquidacion-import',
  AddContainersBLVacioImport = '/billing/mis-liquidaciones-agregar-visita-liquidacion-vacio-import',
  LiquidarRecepcionVacioImport = '/billing/liquidar-recepcion-vacio-import',
  AddContainersBLExport = '/billing/mis-liquidaciones-agregar-visita-liquidacion-exportacion',
  ScheduleLiquidation = '/billing/mis-liquidaciones-agendar-con-rut',
  SheduleRecaudacion = '/billing/mis-liquidaciones-agendar-recalcular',
  LiquidacionesComboBancos = '/billing/pago-bancos',
  PagoValidarDocumento = '/billing/pago-validar-documento',
  PagoBuscarDocumento = '/billing/pago-buscar-documento',
  PagoSistarBanc = '/billing/pago-websistarbanc',
  PagoWeb = '/billing/pago-webbevsa',
  PagoPredocumento = '/billing/pago-total-predocumento',
  PagoDocumentoLiquidacion = '/billing/pago-documentos-liquidacion',
  PagoDocumentoBooking = '/billing/pago-documentos-booking',
  ObtainVisita = '/query/obtain-visita',
  ObtainVisitaAbierta = '/query/obtain-visita-abierta',
  VisitsSettlement = '/billing/mis-liquidaciones-visitas',
  deletedImportFCL = '/billing/mis-liquidaciones-eliminar-visita',
  deleted = '/billing/mis-liquidaciones-eliminar',
  AgregarProforma = '/billing/mis-liquidaciones-agregar-proforma',
  ObtenerProforma = '/billing/mis-liquidaciones-obtener-proforma',
  saveAndAddSettlement = '/billing/mis-liquidaciones-edit',
  PagoFacturarWeb = '/billing/pago-facturar-web',
  ParametroBoolean = '/query/parametro-boolean',
  EsImo = '/query/es-imo',
  VisitaEstaEnStock = '/billing/visita-esta-en-stock',
  ObtenerNumeroProforma = '/billing/mis-liquidaciones-obtener-proforma-numero',
  PendingPayments = '/billing/mis-liquidaciones-cargar-selecciones',
  DeletedPayments = '/billing/mis-liquidaciones-eliminar-seleccion',
  SaveSelection = '/billing/guardar-seleccion',
  EstaEnLiquidacionProforma = '/billing/mis-liquidaciones-esta-liquidacion-proforma',
  DeleteLiquidacionProforma = '/billing/mis-liquidaciones-eliminar-visita-liquidacion-proforma',
  FacturaUnicaPuedeProformar = '/billing/mis-liquidaciones-puede-proformar',
  NecesitaPreguntarPorEarlyArrival = '/billing/mis-liquidaciones-necesita-preguntar-por-early-arrival',
  AccountStatement = '/billing/obtener-posicion-titular',
  EditCommentsAccountStatement = '/billing/actualizar-comentario',
  EliminarLiquidacionDocumentos = '/billing/mis-liquidaciones-eliminar-liquidacion-documentos',
  AgregarLiquidacionDocumentos = '/billing/agregar-documento-liquidacion',
  HistorialModificacionViajes = '/query/modificaciones-viajes',
  CambiarConfiguracion = '/auth/cambiar-configuracion',
  GuardarViajeSuscripcion = '/query/guardar-viaje-suscripcion',
  ServiciosScheduler = '/query/servicios-scheduler',
  ServiciosSuscripto = '/query/servicios-suscripto',
  GuardarServicioSuscripcion = '/query/guardar-servicio-suscripcion',
  SuscribirViajes = '/query/suscribir-viajes',
  ViajeSuscripto = '/query/viajes-suscripto',
  DesubscribirViajes = '/query/desuscribir-viajes',
  TitularCodigo = '/billing/titular-codigo',
  ImprimirComprobanteLiberacion = '/query/comprobante-liberacion',
  LiquidacionesBuscarAbierta = '/billing/mis-liquidaciones-buscar-abierta',
  ImpresionLiquidacion = '/billing/impresion-liquidacion',
  TerminosAceptadosWeb = '/terminos-aceptados-web',
  IngresarFechaAprobacion = '/ingresar-fecha-aprobacion',
  GetParametroTexto = '/query/get-parametro-texto',
  UpdateUserData = '/cambiar-datos-usuario',
  CambiarFechaServicioTerminal = '/billing/mis-liquidaciones-cambiar-fecha-terminal',
  UltimoServicioTerminal = '/billing/mis-liquidaciones-ultimo-servicio',
  ModificarFechaRetiro = '/billing/mis-liquidaciones-modificar-fecha-retiro',
  CambiarEstadoPaga = '/billing/mis-liquidaciones-cambiar-estado-paga',
}

export default Endpoints;
